export interface ChartInterval {
	minutes?: number;
	label?: string;
}
